import { uniqueId } from 'underscore'
import Events from '@/configuration/Events'
import appLoader from '@/common/loader/app'

/** COMPONENTS */
import KryptonCardFormSpawnPoint from '@/host/components/controls/CardFormSpawnPoint'
import SimpleModal from '@/host/components/controls/SimpleModal'
import SmartForm from '@/host/components/smartform/SmartForm'
import FallbackSmartButton from '@/host/components/smartbutton/FallbackSmartButton'
import SmartButtonError from '@/host/components/smartbutton/Error'
import SmartFormCardHeader from '@/host/components/smartform/CardHeader'
import Skeleton from '@/host/components/smartform/Skeleton'
import ExtrasForm from '@/host/components/extrasform/ExtrasForm'
import SmartFormSinglePaymentButton from '@/host/components/smartform/SinglePaymentButton'

/** MIXINS */
import { GlobalThemeMixin } from '@/host/components/mixins/GlobalTheme'

/**
 * @see KJS-4240 | Boot Vue app on KryptonPopinWrapper for legacy+popin
 */
export default locator => {
  return ({ baseAddress, element: $el, customComponents = {} }) => {
    const identifier = uniqueId('krvue-')
    $el.attr('krvue', identifier)

    if ($el.hasClass('kr-smart-form'))
      $el.find('.kr-embedded').attr('krvue', identifier)

    // Legacy + popin mode
    const popinWrapper = $el.closest('.kr-popin-wrapper')
    if (popinWrapper.length) {
      popinWrapper.attr('krvue', identifier)
      popinWrapper.attr('is', 'KryptonPopinWrapper')
      $el = popinWrapper
    }

    return appLoader(locator, $el, {
      el: `[krvue="${identifier}"]`,
      provide: {
        context: {}
      },
      components: {
        KryptonCardFormSpawnPoint,
        SimpleModal,
        SmartForm,
        FallbackSmartButton,
        SmartButtonError,
        SmartFormCardHeader,
        Skeleton,
        ExtrasForm,
        SmartFormSinglePaymentButton,
        ...customComponents
      },
      mixins: [GlobalThemeMixin],
      created() {
        this.$store.dispatch('update', { baseAddress })
      },
      mounted() {
        this.$el.setAttribute('kr-resource', '')
        this.$bus.$emit(Events.krypton.vue.ready)
      }
    })
  }
}
